module.exports = __webpack_public_path__ + "img/OnlineCreation.bc1c23fc.svg";